import Cookies from 'js-cookie'

const cookies = {}

/**
 * @description 存储 cookie 值
 * @param {String} name cookie name
 * @param {String} value cookie value
 * @param {Object} setting cookie setting
 */
cookies.set = function(name = 'default', value = '', cookieSetting = {}) {
  const currentCookieSetting = {
    expires: 1
  }
  if (process.env.NODE_ENV === 'production') {
    currentCookieSetting.domain = document.domain
      .split('.')
      .slice(-2)
      .join('.')
  }
  Object.assign(currentCookieSetting, cookieSetting)
  Cookies.set(
    `admin-${process.env.VUE_APP_VERSION}-${name}`,
    value,
    currentCookieSetting
  )
}

/**
 * @description 拿到 cookie 值
 * @param {String} name cookie name
 */
cookies.get = function(name = 'default') {
  const cookieSetting = {}
  if (process.env.NODE_ENV === 'production') {
    cookieSetting.domain = document.domain
      .split('.')
      .slice(-2)
      .join('.')
  }
  return Cookies.get(
    `admin-${process.env.VUE_APP_VERSION}-${name}`,
    cookieSetting
  )
}

/**
 * @description 拿到 cookie 全部的值
 */
cookies.getAll = function() {
  return Cookies.get()
}

/**
 * @description 删除 cookie
 * @param {String} name cookie name
 */
cookies.remove = function(name = 'default') {
  const cookieSetting = {}
  if (process.env.NODE_ENV === 'production') {
    cookieSetting.domain = document.domain
      .split('.')
      .slice(-2)
      .join('.')
  }
  return Cookies.remove(
    `admin-${process.env.VUE_APP_VERSION}-${name}`,
    cookieSetting
  )
}

export default cookies
